import {
  Box,
  Breadcrumbs,
  Grid,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { events } from "../../../../../data/Data";
import TitleSectionComponent from "../../../../../components/core-components/titleSection";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import { PostsService } from "../../../../../network/PostsService";
import { useQuery } from "@tanstack/react-query";

function EventDetail() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams<{ id: string }>();
  const postsService = new PostsService();

  const {
    data: postDetail,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["postDetail", id],
    queryFn: async () => {
      const res = await postsService.getById(id!);
      return res?.data;
    },
  });

  if (isError) {
    return <div>Event not found</div>;
  }

  return (
    <section
      id="about"
      style={{
        backgroundColor: "var(--bg-color)",
        minHeight: "auto",
        height: "fit-content",
        padding: isMobile ? "20px 10px" : "40px 200px",
      }}
    >
      <div
        className="container"
        style={{
          display: "flex",
          justifyContent: "center",
          padding: isMobile ? "0 10px" : "0",
        }}
      >
        <Grid container mt={isMobile ? 0 : 1} mb={isMobile ? 15 : 15} xs={11}>
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link to="/">
                <span className="B-18" style={{ color: "var(--gray-color)" }}>
                  Ana Sayfa
                </span>
              </Link>
              <Link to="/etkinlikler">
                <span className="B-18" style={{ color: "var(--gray-color)" }}>
                  Etkinlikler
                </span>
              </Link>
              <span className="B-18">{postDetail?.title}</span>
            </Breadcrumbs>
          </Grid>
          <Grid item xs={12} md={12}>
            <TitleSectionComponent
              titleText={postDetail?.title || "Etkinlikler"}
              textAlign="left"
            />
          </Grid>
          <Grid item xs={6} md={6} alignContent={"center"}>
            <span className="B-16">
              {new Date(postDetail?.createdAt).toLocaleDateString()}
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              "& .ql-editor": {
                padding: 0,
                "& img": {
                  maxWidth: "100%",
                  height: "700px",
                  display: "block",
                  margin: "20px auto",
                  borderRadius: "8px",
                },
                "& p": {
                  marginBottom: "1rem",
                  fontSize: "1.1rem",
                  lineHeight: 1.6,
                  color: "var(--text-color)",
                },
                "& h1, & h2, & h3, & h4": {
                  marginTop: "1.5rem",
                  marginBottom: "1rem",
                  color: "var(--text-color)",
                },
                "& ul, & ol": {
                  marginBottom: "1rem",
                  paddingLeft: "2rem",
                },
                "& li": {
                  marginBottom: "0.5rem",
                },
              },
            }}
          >
            <img
              src={postDetail?.image}
              alt={postDetail?.title}
              style={{
                width: "100%",
                height: "850px",
                borderRadius: "16px",
                marginTop: "10px",
                marginBottom: "20px",
                objectFit: "cover",
              }}
            />

            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: postDetail?.content || "" }}
              style={{
                fontSize: isMobile ? "16px" : "18px",
                lineHeight: 1.6,
              }}
            />
          </Grid>
        </Grid>
      </div>
    </section>
  );
}

export default EventDetail;
